import { AnimatePresence, motion } from "framer-motion";

interface PuzzleCompletionProps {
  completedTasks: boolean[];
  merged: boolean;
  onMergeComplete: () => void;
}

const tasks = [
  { icon: "🎤", label: "English" },
  { icon: "🎤", label: "Telugu" },
  { icon: "✏️", label: "Drawing" },
];

const PuzzleCompletion = ({
  completedTasks,
  merged,
  onMergeComplete,
}: PuzzleCompletionProps) => {
  const allComplete = completedTasks.every(Boolean);

  return (
    <div className="flex flex-col items-center gap-4">
      <AnimatePresence>
        {!merged && (
          <motion.div className="flex items-center gap-6" exit={{ opacity: 0 }}>
            {tasks.map((task, i) => (
              <motion.div
                key={task.label}
                className="flex flex-col items-center gap-2"
                animate={
                  allComplete && !merged
                    ? { x: i === 0 ? 60 : i === 2 ? -60 : 0, scale: 0.8 }
                    : {}
                }
                transition={{ delay: 0.3, duration: 0.6, ease: "easeInOut" }}
                onAnimationComplete={() => {
                  if (allComplete && i === 1) {
                    setTimeout(onMergeComplete, 400);
                  }
                }}
              >
                <motion.div
                  className={`relative flex h-16 w-16 items-center justify-center rounded-full text-2xl shadow-md ${
                    completedTasks[i] ? "bg-emerald-500" : "bg-slate-200"
                  }`}
                  animate={completedTasks[i] ? { scale: [1, 1.2, 1] } : {}}
                  transition={{ duration: 0.4 }}
                >
                  {task.icon}
                  {completedTasks[i] && (
                    <motion.span
                      className="absolute -right-1 -top-1 text-lg text-amber-500"
                      initial={{ scale: 0, rotate: -180 }}
                      animate={{ scale: 1, rotate: 0 }}
                    >
                      ⭐
                    </motion.span>
                  )}
                </motion.div>
                <span className="text-xs font-bold text-slate-600">{task.label}</span>
              </motion.div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {merged && (
          <motion.div
            className="h-20 w-20 rounded-full bg-gradient-to-br from-amber-400 to-blue-500 shadow-2xl"
            initial={{ scale: 0, opacity: 0 }}
            animate={{
              scale: [0, 1.3, 1],
              opacity: 1,
              boxShadow: [
                "0 0 0 0 rgba(251, 191, 36, 0.5)",
                "0 0 30px 10px rgba(251, 191, 36, 0.6)",
                "0 0 20px 5px rgba(251, 191, 36, 0.35)",
              ],
            }}
            exit={{ scale: 0, y: 60, opacity: 0 }}
            transition={{ duration: 0.6 }}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default PuzzleCompletion;